module.exports = __webpack_public_path__ + "img/2714.02c191ca.svg";